import React from 'react';
import PropTypes from 'prop-types';
import CustomMarker from './Marker';

// render all pins on map
const UnClusteredPins = ({ markers }) =>
  markers.map(
    (
      { latLng, description, number, assigned, inside, phaseType },
      index,
    ) => {
      let color = 'white.png';

      if (inside === true) {
        if (assigned.length > 0) {
          if (phaseType === 'Single') {
            color = 'blue.png';
          } else if (phaseType === 'Three') {
            color = 'purple.png';
          }
        } else if (!(assigned.length > 0)) {
          if (phaseType === 'Single') {
            color = 'red.png';
          } else if (phaseType === 'Three') {
            color = 'orange.png';
          }
        }
      } else if (inside === false) {
        if (assigned.length > 0) {
          if (phaseType === 'Single') {
            color = 'blue.png';
          } else if (phaseType === 'Three') {
            color = 'purple.png';
          }
        } else if (!(assigned.length > 0)) {
          if (phaseType === 'Single') {
            color = 'green.png';
          } else if (phaseType === 'Three') {
            color = 'yellow.png';
          }
        }
      }

      console.log('unclustered pin color', color);

      return (
        <CustomMarker
          description={description}
          position={latLng}
          key={index}
          color={color}
        />
      );
    },
  );

UnClusteredPins.propTypes = {
  markers: PropTypes.array.isRequired,
};

export default UnClusteredPins;
